const serviceData = [
  {
    id: 1,
    title: "City Transfer",
    icon: "ri-map-pin-2-line",
    desc: "Experience the ease of city-to-city travel with our efficient transfers. Connect seamlessly between Nairobi, Mombasa, and more.",
  },

  {
    id: 2,
    title: "Whole  City Tour",
    icon: "ri-community-line",
    desc: "Explore Nairobi's hidden treasures and iconic landmarks with our guided tours. Discover the heart of the city.",
  },

  {
    id: 3,
    title: "Unlimited Distance Car Rental",
    icon: "ri-roadster-line",
    desc: "Drive without limits with our unlimited kilometers. Explore Kenya's diverse landscapes without constraints.",
  },

  {
    id: 4,
    title: "Fast & Easy Booking",
    icon: "ri-timer-flash-line",
    desc: "Our user-friendly online booking system ensures a quick and hassle-free reservation process.",
  },

  {
    id: 5,
    title: "Many Pickup Locations",
    icon: "ri-map-pin-line",
    desc: "Convenience at your doorstep. Choose from a variety of pickup points across Kenya.",
  },

  {
    id: 6,
    title: "Airport Transfer",
    icon: "ri-flight-takeoff-line",
    desc: "Start your journey stress-free with our reliable airport transfer services.",
  },
];

export default serviceData;
